const DESKTOP_EMOJI_PICKER_LAYOUT = {
  panelWidth: 340,
  panelHeight: 320,
  perLine: 9,
  emojiButtonSize: 34.5,
};

const MOBILE_EMOJI_PICKER_LAYOUT = {
  panelWidth: 310,
  panelHeight: 300,
  // Fewer columns on mobile, with larger buttons to keep rows visually full.
  perLine: 7,
  emojiButtonSize: 40,
};

export const getChatEmojiPickerLayout = ({ isMobile = false } = {}) =>
  isMobile ? MOBILE_EMOJI_PICKER_LAYOUT : DESKTOP_EMOJI_PICKER_LAYOUT;
